import React, { useEffect, Fragment, useState } from "react";
import { Row, Col } from "reactstrap";
import { MODULE_API } from "../../apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../components/styled-components/loader/loader";
import Trust from "../../assets/images/latest/Trust.png";
import Insurance from "../../assets/images/latest/Insurance.png";
import Networth2 from "../../assets/images/latest/Networth2.png";
import Vacation from "../../assets/images/latest/Vacation-Home.png";

const InsuranceSelection = () => {
  const [loading, setIsLoading] = useState(true);
  const history = useHistory();

  const [annuitydata, setAnnuityData] = useState([]);
  const [healthdata, setHealthData] = useState([]);
  const [casualtydata, setCasualtyData] = useState([]);
  const [insurancedata, setDataInsurance] = useState([]);

  const getAllInsuranceAssets = async () => {
    setIsLoading(true);
    let data = await MODULE_API.insuraceAllocation("Insurance Products V2");
    if (data && data.data) {
      console.log("data inside insuarce", data.data);
      data.data.map((item) => {
        if (item.name === "Annuity/Contract") {
          console.log("item.child", item.child);
          setAnnuityData(item.child);
        }
        if (item.name === "Life and Health") {
          setHealthData(item.child);
        }
        if (item.name === "Property and Casualty") {
          setCasualtyData(item.child);
        }
        if (item.name === "Long Term Care/Disability") {
          setDataInsurance(item.child);
        }
      });
    }
    setIsLoading(false);
  };

  const handleInsuranceSelect = (name) => {
    history.push(`/organizer/insurance/attributes/${name}`);
  };
  useEffect(() => {
    getAllInsuranceAssets();
  }, []);

  return (
    <Fragment>
      <div className="info-form-block">
        <Row gutter={16}>
          <Col span={24}>
            <h2
              className="text-center font-weight-bold mb-4"
              style={{ fontFamily: "Poppins" }}
            >
              Select the Type of Insurance
            </h2>
          </Col>
        </Row>
      </div>
      <div className="selelctmain">
        <div className="submainImage">
          <img src={Networth2} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Property and Casualty</h3>
        </div>
        <div className="selectmainincome">
          {casualtydata &&
            casualtydata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleInsuranceSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name && item.name.replace(/\sV2$/, "") }</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="submainImage">
          <img src={Insurance} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Life and Health</h3>
        </div>
        <div className="selectmainincome">
          {healthdata &&
            healthdata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleInsuranceSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name && item.name.replace(/\sV2$/, "")}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="submainImage">
          <img src={Vacation} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Long Term Care/Disability</h3>
        </div>
        <div className="selectmainincome">
          {insurancedata &&
            insurancedata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleInsuranceSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name && item.name.replace(/\sV2$/, "")}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="submainImage">
          <img src={Trust} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Annuity/Contract</h3>
        </div>
        <div className="selectmainincome">
          {annuitydata &&
            annuitydata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleInsuranceSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name && item.name.replace(/\sV2$/, "")}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <Loader isLoading={loading} />
    </Fragment>
  );
};

export default InsuranceSelection;
